<template>
  <div class="create-users-form">
    <h1 class="middle-high">{{ nameUserForm }}</h1>
    <div class="change-passford-form" v-if="flagChangeForm">
      
      <el-card style="max-width: 100%" shadow="never" body-style="padding: 15px 5px 0 5px;">
        <template #header>Изменить пароль:</template>
        <el-form :model="formChangePassword" label-width="auto" style="max-width: 100%" size="small">
          <el-form-item label="Пароль">
            <el-input v-model="formChangePassword.password" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="changePassword">Изменить</el-button>
            <el-button @click="closeFormChangePass">Отменить</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <el-card style="max-width: 100%" shadow="never" body-style="padding: 15px 5px 0 5px;">
      <template #header>Добавить нового пользователя:</template>
      <el-form :model="formAddUser" label-width="auto" style="max-width: 100%" size="small">
        <el-form-item label="Логин">
          <el-input v-model="formAddUser.login" />
        </el-form-item>
        <el-form-item label="Пароль">
          <el-input v-model="formAddUser.password" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickAddNewUser">Добавить</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="max-width: 100%" shadow="never" body-style="padding: 15px 5px 0 5px;">
      <template #header>Изменить параметры компании:</template>
      <el-form :model="formChangeCompany" label-width="auto" style="max-width: 100%" size="small">
        <el-form-item label="Название компании:">
          <el-input v-model="formChangeCompany.showingName" :placeholder="nameUserForm" />
        </el-form-item>
        <el-form-item label="Короткое имя на Английскоми:">
          <el-input v-model="formChangeCompany.name" :placeholder="shortNameCompanyForm" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickChangeName">Изменить</el-button>
        </el-form-item>
        <!-- <input type="text" v-model="nameCompany" class="plain-text"
          :placeholder="'Название компании (' + nameUserForm + ')'">
        <input type="text" v-model="shortNameCompany" class="plain-text"
          :placeholder="'Короткое имя на Английскоми (' + shortNameCompanyForm + ')'"> -->
        <!-- <button class="plain-text" @click="clickChangeName">Изменить</button> -->
      </el-form>
    </el-card>
    
  </div>
</template>

<script>

export default {
  name: 'UsersForm',
  props: ['nameUserForm', 'shortNameCompanyForm', 'idCompany', 'flagChangeForm', 'idUserChangedPassword', 'paramUserChangePassword'],
  emits: ['changeCompany', 'addNewUser', 'closeFormChangePassword', 'changePassword'],
  computed: {
  },
  data() {
    return {
      shortNameCompany: '',
      nameCompany: '',
      loginValue: '',
      passwordValue: '',
      changingPassword: '',
      formChangePassword: {
        password: ''
      },
      formAddUser: {
        login: '',
        password: ''
      },
      formChangeCompany: {
        showingName: '',
        name: ''
      }
    }
  },
  components: {
  },
  methods: {
    clickAddNewUser() {
      const options = {
        username: this.formAddUser.login,
        password: this.formAddUser.password
      }
      this.$emit('addNewUser', options)
      this.formAddUser.login = ''
      this.formAddUser.password = ''
    },
    clickChangeName() {
      let options = {
        id: this.idCompany
      }
      if (this.nameCompany == '' && this.shortNameCompany == '') {
        return;
      }
      if (this.nameCompany != '') {
        options.showing_name = this.nameCompany
      } else {
        options.showing_name = this.nameUserForm
      }
      if (this.shortNameCompany != '') {
        options.name = this.shortNameCompany
      } else {
        options.name = this.shortNameCompanyForm
      }
      this.shortNameCompany = ''
      this.nameCompany = ''
      this.$emit('changeCompany', options)

    },
    closeFormChangePass() {
      this.$emit('closeFormChangePassword')
    },
    changePassword() {
      let options = {}
      options.id = this.paramUserChangePassword.id
      options.password = this.formChangePassword.password
      this.$emit('changePassword', options)
      this.formChangePassword.password = ''
    }
  },
  created() {
    // this.shortNameCompany = this.shortNameCompany
    // this.nameCompany = this.nameUserForm
  },
  beforeUnmount() {
  }
}
</script>

<style noscoped lang="scss">
.create-users-form {
  display: flex;
  flex-direction: column;
  padding: 0 25px;

  .change-passford-form {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: all .3s ease;

    .abnormal-button {
      margin: 20px 0;
    }
  }

  .name-form {
    margin-top: 25px;
  }

  // input {
  //   border: 1px solid var(--gray-dark-color);
  //   border-radius: 4px;
  //   padding: 3px 6px;
  //   margin-top: 20px;
  // }

  // button {
  //   border-radius: 8px;
  //   background: var(--background-blue);
  //   color: #fff;
  //   padding: 6px 50px;
  //   margin-top: 20px;
  //   margin-left: auto;
  //   transition: all .1s ease;

  //   &:hover {
  //     background: #3f51b5d0;
  //   }

  //   &:active {
  //     background: #3f51b55e;
  //   }
  // }
}
</style>
